import { useState } from 'react';
import { HeaderPage } from 'components';
import {
  MEDIOS_IMPRESOS_SELECTOR,
  MEDIDAS_CAT_SELECTOR,
  catalogsTypes
} from 'constants/configuracionTiposCatalogos';
import { CatalogSelector } from 'components/CatalogSelector/CatalogSelector';
import { TablaCatalogo } from './componentes/TablaCatalogo';
import './CatalogoMediosImpresos.scss';

const CatalogoMediosImpresos = () => {
  const [selecccionComponente, setSeleccionComponente] = useState(MEDIOS_IMPRESOS_SELECTOR);
  const [isSameComponent, setIsSameComponent] = useState(true);
  return (
    <div className="catalogo-medios-impresos">
      <HeaderPage
        section="Configuración de Catálogos"
        section2="Administración del Catálogo de Medios impresos"
        title=" "
        header="Selecciona el catálogo que deseas administrar."
      />
      <div className="selector-catalogos">
        <CatalogSelector
          initialValues={{
            componente: selecccionComponente,
            tipoCatalogo: isSameComponent ? MEDIDAS_CAT_SELECTOR : undefined
          }}
          opcionesCatalogo={catalogsTypes.MediosImpresos}
          setSeleccionComponente={setSeleccionComponente}
          setIsSameComponent={setIsSameComponent}
        />
        {isSameComponent && (
          <>
            <div className="catalogs-subheader">
              <p className="title-catalogs">Administración del Catálogo de Medios impresos</p>
            </div>
            <div className="header-catalogs-label-information" style={{ marginBottom: '20px' }}>
              Selecciona al menos un campo para realizar la búsqueda.
            </div>
          </>
        )}
      </div>
      {isSameComponent && <TablaCatalogo />}
    </div>
  );
};

export default CatalogoMediosImpresos;
